/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AiDetectRouteImport } from './routes/ai-detect'
import { Route as AiDisputesRouteImport } from './routes/ai-disputes'
import { Route as AnnouncementsRouteImport } from './routes/announcements'
import { Route as AppealsRouteImport } from './routes/appeals'
import { Route as EmbedsRouteImport } from './routes/embeds'
import { Route as GiveawayRouteImport } from './routes/giveaway'
import { Route as GroovesRouteImport } from './routes/grooves'
import { Route as LiveRouteImport } from './routes/live'
import { Route as MailRouteImport } from './routes/mail'
import { Route as MfaRecoveryRouteImport } from './routes/mfa-recovery'
import { Route as ModerationRouteImport } from './routes/moderation'
import { Route as MusicRouteImport } from './routes/music'
import { Route as ProfessionsRouteImport } from './routes/professions'
import { Route as StageRouteImport } from './routes/stage'
import { Route as StoreRouteImport } from './routes/store'
import { Route as VerificationRouteImport } from './routes/verification'
import { Route as MailIndexRouteImport } from './routes/mail.index'
import { Route as MailCalendarRouteImport } from './routes/mail.calendar'
import { Route as SettingsMailRouteImport } from './routes/settings.mail'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AiDetectRoute = AiDetectRouteImport.update({
  id: '/ai-detect',
  path: '/ai-detect',
  getParentRoute: () => rootRouteImport,
} as any)
const AiDisputesRoute = AiDisputesRouteImport.update({
  id: '/ai-disputes',
  path: '/ai-disputes',
  getParentRoute: () => rootRouteImport,
} as any)
const AnnouncementsRoute = AnnouncementsRouteImport.update({
  id: '/announcements',
  path: '/announcements',
  getParentRoute: () => rootRouteImport,
} as any)
const AppealsRoute = AppealsRouteImport.update({
  id: '/appeals',
  path: '/appeals',
  getParentRoute: () => rootRouteImport,
} as any)
const EmbedsRoute = EmbedsRouteImport.update({
  id: '/embeds',
  path: '/embeds',
  getParentRoute: () => rootRouteImport,
} as any)
const GiveawayRoute = GiveawayRouteImport.update({
  id: '/giveaway',
  path: '/giveaway',
  getParentRoute: () => rootRouteImport,
} as any)
const GroovesRoute = GroovesRouteImport.update({
  id: '/grooves',
  path: '/grooves',
  getParentRoute: () => rootRouteImport,
} as any)
const LiveRoute = LiveRouteImport.update({
  id: '/live',
  path: '/live',
  getParentRoute: () => rootRouteImport,
} as any)
const MailRoute = MailRouteImport.update({
  id: '/mail',
  path: '/mail',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaRecoveryRoute = MfaRecoveryRouteImport.update({
  id: '/mfa-recovery',
  path: '/mfa-recovery',
  getParentRoute: () => rootRouteImport,
} as any)
const ModerationRoute = ModerationRouteImport.update({
  id: '/moderation',
  path: '/moderation',
  getParentRoute: () => rootRouteImport,
} as any)
const MusicRoute = MusicRouteImport.update({
  id: '/music',
  path: '/music',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfessionsRoute = ProfessionsRouteImport.update({
  id: '/professions',
  path: '/professions',
  getParentRoute: () => rootRouteImport,
} as any)
const StageRoute = StageRouteImport.update({
  id: '/stage',
  path: '/stage',
  getParentRoute: () => rootRouteImport,
} as any)
const StoreRoute = StoreRouteImport.update({
  id: '/store',
  path: '/store',
  getParentRoute: () => rootRouteImport,
} as any)
const VerificationRoute = VerificationRouteImport.update({
  id: '/verification',
  path: '/verification',
  getParentRoute: () => rootRouteImport,
} as any)
const MailIndexRoute = MailIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MailRoute,
} as any)
const MailCalendarRoute = MailCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => MailRoute,
} as any)
const SettingsMailRoute = SettingsMailRouteImport.update({
  id: '/settings/mail',
  path: '/settings/mail',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/ai-detect': typeof AiDetectRoute
  '/ai-disputes': typeof AiDisputesRoute
  '/announcements': typeof AnnouncementsRoute
  '/appeals': typeof AppealsRoute
  '/embeds': typeof EmbedsRoute
  '/giveaway': typeof GiveawayRoute
  '/grooves': typeof GroovesRoute
  '/live': typeof LiveRoute
  '/mail': typeof MailRouteWithChildren
  '/mfa-recovery': typeof MfaRecoveryRoute
  '/moderation': typeof ModerationRoute
  '/music': typeof MusicRoute
  '/professions': typeof ProfessionsRoute
  '/stage': typeof StageRoute
  '/store': typeof StoreRoute
  '/verification': typeof VerificationRoute
  '/mail/calendar': typeof MailCalendarRoute
  '/settings/mail': typeof SettingsMailRoute
  '/mail/': typeof MailIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/ai-detect': typeof AiDetectRoute
  '/ai-disputes': typeof AiDisputesRoute
  '/announcements': typeof AnnouncementsRoute
  '/appeals': typeof AppealsRoute
  '/embeds': typeof EmbedsRoute
  '/giveaway': typeof GiveawayRoute
  '/grooves': typeof GroovesRoute
  '/live': typeof LiveRoute
  '/mfa-recovery': typeof MfaRecoveryRoute
  '/moderation': typeof ModerationRoute
  '/music': typeof MusicRoute
  '/professions': typeof ProfessionsRoute
  '/stage': typeof StageRoute
  '/store': typeof StoreRoute
  '/verification': typeof VerificationRoute
  '/mail/calendar': typeof MailCalendarRoute
  '/settings/mail': typeof SettingsMailRoute
  '/mail': typeof MailIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/ai-detect': typeof AiDetectRoute
  '/ai-disputes': typeof AiDisputesRoute
  '/announcements': typeof AnnouncementsRoute
  '/appeals': typeof AppealsRoute
  '/embeds': typeof EmbedsRoute
  '/giveaway': typeof GiveawayRoute
  '/grooves': typeof GroovesRoute
  '/live': typeof LiveRoute
  '/mail': typeof MailRouteWithChildren
  '/mfa-recovery': typeof MfaRecoveryRoute
  '/moderation': typeof ModerationRoute
  '/music': typeof MusicRoute
  '/professions': typeof ProfessionsRoute
  '/stage': typeof StageRoute
  '/store': typeof StoreRoute
  '/verification': typeof VerificationRoute
  '/mail/calendar': typeof MailCalendarRoute
  '/settings/mail': typeof SettingsMailRoute
  '/mail/': typeof MailIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/ai-detect'
    | '/ai-disputes'
    | '/announcements'
    | '/appeals'
    | '/embeds'
    | '/giveaway'
    | '/grooves'
    | '/live'
    | '/mail'
    | '/mfa-recovery'
    | '/moderation'
    | '/music'
    | '/professions'
    | '/stage'
    | '/store'
    | '/verification'
    | '/mail/calendar'
    | '/settings/mail'
    | '/mail/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/ai-detect'
    | '/ai-disputes'
    | '/announcements'
    | '/appeals'
    | '/embeds'
    | '/giveaway'
    | '/grooves'
    | '/live'
    | '/mfa-recovery'
    | '/moderation'
    | '/music'
    | '/professions'
    | '/stage'
    | '/store'
    | '/verification'
    | '/mail/calendar'
    | '/settings/mail'
    | '/mail'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/ai-detect'
    | '/ai-disputes'
    | '/announcements'
    | '/appeals'
    | '/embeds'
    | '/giveaway'
    | '/grooves'
    | '/live'
    | '/mail'
    | '/mfa-recovery'
    | '/moderation'
    | '/music'
    | '/professions'
    | '/stage'
    | '/store'
    | '/verification'
    | '/mail/calendar'
    | '/settings/mail'
    | '/mail/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  AiDetectRoute: typeof AiDetectRoute
  AiDisputesRoute: typeof AiDisputesRoute
  AnnouncementsRoute: typeof AnnouncementsRoute
  AppealsRoute: typeof AppealsRoute
  EmbedsRoute: typeof EmbedsRoute
  GiveawayRoute: typeof GiveawayRoute
  GroovesRoute: typeof GroovesRoute
  LiveRoute: typeof LiveRoute
  MailRoute: typeof MailRouteWithChildren
  MfaRecoveryRoute: typeof MfaRecoveryRoute
  ModerationRoute: typeof ModerationRoute
  MusicRoute: typeof MusicRoute
  ProfessionsRoute: typeof ProfessionsRoute
  StageRoute: typeof StageRoute
  StoreRoute: typeof StoreRoute
  VerificationRoute: typeof VerificationRoute
  SettingsMailRoute: typeof SettingsMailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-detect': {
      id: '/ai-detect'
      path: '/ai-detect'
      fullPath: '/ai-detect'
      preLoaderRoute: typeof AiDetectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ai-disputes': {
      id: '/ai-disputes'
      path: '/ai-disputes'
      fullPath: '/ai-disputes'
      preLoaderRoute: typeof AiDisputesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/announcements': {
      id: '/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AnnouncementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/appeals': {
      id: '/appeals'
      path: '/appeals'
      fullPath: '/appeals'
      preLoaderRoute: typeof AppealsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embeds': {
      id: '/embeds'
      path: '/embeds'
      fullPath: '/embeds'
      preLoaderRoute: typeof EmbedsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/giveaway': {
      id: '/giveaway'
      path: '/giveaway'
      fullPath: '/giveaway'
      preLoaderRoute: typeof GiveawayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grooves': {
      id: '/grooves'
      path: '/grooves'
      fullPath: '/grooves'
      preLoaderRoute: typeof GroovesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/live': {
      id: '/live'
      path: '/live'
      fullPath: '/live'
      preLoaderRoute: typeof LiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mail': {
      id: '/mail'
      path: '/mail'
      fullPath: '/mail'
      preLoaderRoute: typeof MailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa-recovery': {
      id: '/mfa-recovery'
      path: '/mfa-recovery'
      fullPath: '/mfa-recovery'
      preLoaderRoute: typeof MfaRecoveryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/moderation': {
      id: '/moderation'
      path: '/moderation'
      fullPath: '/moderation'
      preLoaderRoute: typeof ModerationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/music': {
      id: '/music'
      path: '/music'
      fullPath: '/music'
      preLoaderRoute: typeof MusicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/professions': {
      id: '/professions'
      path: '/professions'
      fullPath: '/professions'
      preLoaderRoute: typeof ProfessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stage': {
      id: '/stage'
      path: '/stage'
      fullPath: '/stage'
      preLoaderRoute: typeof StageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/store': {
      id: '/store'
      path: '/store'
      fullPath: '/store'
      preLoaderRoute: typeof StoreRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verification': {
      id: '/verification'
      path: '/verification'
      fullPath: '/verification'
      preLoaderRoute: typeof VerificationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mail/': {
      id: '/mail/'
      path: '/'
      fullPath: '/mail/'
      preLoaderRoute: typeof MailIndexRouteImport
      parentRoute: typeof MailRoute
    }
    '/mail/calendar': {
      id: '/mail/calendar'
      path: '/calendar'
      fullPath: '/mail/calendar'
      preLoaderRoute: typeof MailCalendarRouteImport
      parentRoute: typeof MailRoute
    }
    '/settings/mail': {
      id: '/settings/mail'
      path: '/settings/mail'
      fullPath: '/settings/mail'
      preLoaderRoute: typeof SettingsMailRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface MailRouteChildren {
  MailCalendarRoute: typeof MailCalendarRoute
  MailIndexRoute: typeof MailIndexRoute
}

const MailRouteChildren: MailRouteChildren = {
  MailCalendarRoute: MailCalendarRoute,
  MailIndexRoute: MailIndexRoute,
}

const MailRouteWithChildren = MailRoute._addFileChildren(MailRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  AiDetectRoute: AiDetectRoute,
  AiDisputesRoute: AiDisputesRoute,
  AnnouncementsRoute: AnnouncementsRoute,
  AppealsRoute: AppealsRoute,
  EmbedsRoute: EmbedsRoute,
  GiveawayRoute: GiveawayRoute,
  GroovesRoute: GroovesRoute,
  LiveRoute: LiveRoute,
  MailRoute: MailRouteWithChildren,
  MfaRecoveryRoute: MfaRecoveryRoute,
  ModerationRoute: ModerationRoute,
  MusicRoute: MusicRoute,
  ProfessionsRoute: ProfessionsRoute,
  StageRoute: StageRoute,
  StoreRoute: StoreRoute,
  VerificationRoute: VerificationRoute,
  SettingsMailRoute: SettingsMailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
